import CrudCustom from '../../../libs/custom/CrudCustom';

let AsetService = new CrudCustom('/asets');
export default AsetService;
